import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "../api";
import { useCart } from "../context/CartContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [orderId, setOrderId] = useState(null);
  const { clear } = useCart();
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          setOrderId(data.order_id);
          clear();
          return;
        }
      } catch {}
      attempts.current += 1;
      if (attempts.current < 15) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <main className="mx-auto flex min-h-[70vh] max-w-lg flex-col items-center justify-center px-4 pt-24 text-center" data-testid="payment-success-page">
      {status === "checking" && (
        <>
          <Loader2 className="h-14 w-14 animate-spin text-cyan-400" />
          <h1 className="mt-6 font-display text-2xl font-bold">Potwierdzamy płatność...</h1>
          <p className="mt-2 text-sm text-slate-400">To zajmie tylko chwilę.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 className="h-16 w-16 text-emerald-400" />
          <h1 className="mt-6 font-display text-3xl font-extrabold">Dziękujemy za zakup!</h1>
          <p className="mt-3 text-sm leading-relaxed text-slate-400">
            Zamówienie <span className="font-mono font-bold text-cyan-300">{orderId}</span> zostało opłacone.
            Link do pobrania plików wysłaliśmy na Twój adres email. Miłego czytania i słuchania!
          </p>
          <Link to="/" className="mt-8 rounded-full bg-gradient-to-r from-cyan-500 to-teal-500 px-8 py-3 font-display text-sm font-bold text-slate-950 transition-transform hover:scale-105">
            Wróć do sklepu
          </Link>
        </>
      )}
      {(status === "timeout" || status === "error") && (
        <>
          <XCircle className="h-14 w-14 text-amber-400" />
          <h1 className="mt-6 font-display text-2xl font-bold">Sprawdzamy status płatności</h1>
          <p className="mt-2 text-sm text-slate-400">Jeśli płatność została zaksięgowana, pliki otrzymasz na email. W razie pytań napisz do nas przez czat.</p>
          <Link to="/" className="mt-8 rounded-full glass-panel px-8 py-3 text-sm font-semibold text-slate-200">Wróć do sklepu</Link>
        </>
      )}
    </main>
  );
}

export function PaymentCancel() {
  return (
    <main className="mx-auto flex min-h-[70vh] max-w-lg flex-col items-center justify-center px-4 pt-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="h-16 w-16 text-rose-400" />
      <h1 className="mt-6 font-display text-3xl font-extrabold">Płatność anulowana</h1>
      <p className="mt-3 text-sm text-slate-400">Nie pobraliśmy żadnych środków. Twój koszyk został zachowany — możesz dokończyć zakup w dowolnym momencie.</p>
      <Link to="/" className="mt-8 rounded-full bg-gradient-to-r from-cyan-500 to-teal-500 px-8 py-3 font-display text-sm font-bold text-slate-950 transition-transform hover:scale-105">
        Wróć do koszyka
      </Link>
    </main>
  );
}
